import { Flex } from '@applyboard/crystal-ui';

import { ProgramDetailsHeading } from '../components/ProgramDetailsHeading';
import { ProgramInformation } from '../components/ProgramInformation';

export function DesktopLayout() {
  return (
    <Flex p={10} gap={8} direction="column">
      <ProgramDetailsHeading />
      <ProgramInformation />
    </Flex>
  );
}
